module.exports = __webpack_public_path__ + "static/img/Boss_31088.c9cf0fb1.png";